import { useTranslation } from "@hooks/useTranslation";
import FilterButton from "./filter-button";
import FilterOption from "./filter-option";

type SortOption = {
  id: string;
  value: string;
};

const SortBy = ({
  sortOptions,
  by,
  onSelect,
}: {
  sortOptions: SortOption[];
  by?: SortOption;
  onSelect: (option: SortOption) => void;
}) => {
  const { t } = useTranslation();

  return (
    <FilterOption name={t("spotprofile.experiences.filters.sort_by")}>
      <div className="grid items-center justify-between grid-cols-2 gap-2 mb-3">
        {sortOptions.map((option) => {
          const isActive = option.id === by?.id;
          return (
            <FilterButton
              key={option.id}
              isActive={isActive}
              onClick={() => onSelect(option)}
              className="!w-full"
            >
              <p
                className={`text-center w-full ${
                  isActive ? "text-primary-color" : ""
                }`}
              >
                {option.value}
              </p>
            </FilterButton>
          );
        })}
      </div>
    </FilterOption>
  );
};

export default SortBy;
